/** Prefix used to scope usernames in Okta by brand. */
export enum IdentityNamespace {
  LyraHealth = '',
  BendHealth = 'bh',
}

/**
 * Mirrors the Okta sign-in widget's `UserOperation` so this module stays free of widget imports and
 * can be used from React Native, where the widget is not available.
 */
export type OktaUsernameOperation = 'PRIMARY_AUTH' | 'FORGOT_PASSWORD' | 'UNLOCK_ACCOUNT'
export type TransformUsername = (username: string, operation: OktaUsernameOperation) => string

const IDENTITY_NAMESPACE_BY_CUSTOMER_NAME: Record<string, IdentityNamespace> = {
  bendbootcamp: IdentityNamespace.BendHealth,
}

export const resolveIdentityNamespace = (customerName?: string): IdentityNamespace =>
  (customerName && IDENTITY_NAMESPACE_BY_CUSTOMER_NAME[customerName]) || IdentityNamespace.LyraHealth

export const namespaceUsername = (namespace: IdentityNamespace, username: string): string => {
  if (namespace === IdentityNamespace.LyraHealth) {
    return username
  }
  return `${namespace}:${username.trim().toLowerCase()}`
}

export const createTransformUsername = (namespace: IdentityNamespace): TransformUsername | undefined => {
  if (namespace === IdentityNamespace.LyraHealth) {
    return undefined
  }

  // Password reset and account recovery is handled by LyraWebAPI rather than the widget,
  // so in practice only the PRIMARY_AUTH operation reaches this.
  return (username: string, _operation: OktaUsernameOperation): string => namespaceUsername(namespace, username)
}
